import React from 'react';
import { UniversalEditorContext } from '../context/universal-editor-context';
import { findModelAndFragmentForPath } from '../utils';
import { isContentFragment } from '../../content-types';
import { UeElement } from './ue-element';
export const UeReference = ({ propertyPath, behavior, children, as, label, }) => {
    const ueContext = React.useContext(UniversalEditorContext);
    const { resource, finalLabel, lastProperty } = React.useMemo(() => {
        if (!ueContext.isAuthorMode || !ueContext.isFalconContent) {
            return { resource: '', finalLabel: '', lastProperty: '' };
        }
        const modelAndFragment = findModelAndFragmentForPath(ueContext.rawCmsContent, propertyPath);
        if (!isContentFragment(modelAndFragment?.fragment)) {
            console.warn(`We could not find a reference for the propertyPath "${propertyPath}"`);
            return { resource: '', finalLabel: '', lastProperty: '' };
        }
        return {
            resource: modelAndFragment?.fragment?.contentPath,
            finalLabel: label || modelAndFragment?.fragment?.model?.title,
            lastProperty: modelAndFragment?.lastPropertyName,
        };
    }, [propertyPath, ueContext, label]);
    return (React.createElement(UeElement, { type: "reference", property: behavior === 'component' ? undefined : lastProperty, label: finalLabel, resource: resource, as: as, behavior: behavior }, children));
};
//# sourceMappingURL=ue-reference.js.map